import { TUTORIAL_MARK_AS_READ, TUTORIAL_RESET } from '../types'

const state = {
  isTutorialRead: localStorage.getItem('printTagTutorial') || false
}

const mutations = {
  [TUTORIAL_MARK_AS_READ](state) {
    state.isTutorialRead = true
    localStorage.setItem('printTagTutorial', true)
  },
  [TUTORIAL_RESET](state) {
    state.isTutorialRead = false
    localStorage.setItem('printTagTutorial', false)
  }
}

const getters = {
  isTutorialRead: state => {
    return state.isTutorialRead
  }
}

const actions = {
  markTutorialAsRead: function ({ commit }) {
    commit(TUTORIAL_MARK_AS_READ)
  },
  resetTutorial: function ({ commit }) {
    commit(TUTORIAL_RESET)
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
